export default __webpack_public_path__ + "static/kingston-logo-e86f601fe66461771e07e0296437473f.svg";